<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-0 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/project"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="20"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="16"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="fs-16 black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Project
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pb-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                height="calc(100vh - 220px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider
                            name="Nama Project" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
                              Nama Project
                            </div>

                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Nama Project"

                              hide-details
                              autofocus

                              v-model="form.name"
                              :success="form.name !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider
                            name="Kode" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
                              Kode Project
                            </div>

                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Kode"

                              hide-details

                              v-model="form.code"
                              :success="form.code !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.code !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Pemberi tugas" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Pemberi tugas
                            </div>
        
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Pemberi tugas"
        
                              hide-details
                              item-text="name"
                              item-value="id"
                              :items="client"
        
                              v-model="form.client_id"
                              :success="form.client_id !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.client_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Lokasi Project" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Lokasi Project
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Lokasi Project"
        
                              hide-details
        
                              v-model="form.location"
                              :success="form.location !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.location !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Nomor Permohonan" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Nomor Permohonan
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Nomor Permohonan"
        
                              hide-details
        
                              v-model="form.request_number"
                              :success="form.request_number !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.request_number !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Tanggal Permohonan" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Tanggal Permohonan
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Tanggal Permohonan"
        
                              hide-details
                              type="date"
        
                              v-model="form.request_date"
                              :success="form.request_date !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.request_date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Type Durasi Pekerjaan" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Type Durasi Pekerjaan
                            </div>
        
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Type Durasi Pekerjaan"
        
                              hide-details
                              :items="[
                                {
                                  label: 'Hari',
                                  value: 'hari'
                                },
                                {
                                  label: 'Minggu',
                                  value: 'minggu'
                                }
                              ]"
                              item-text="label"
                              item-value="value"
        
                              v-model="form.duration_label"
                              :success="form.duration_label !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.duration_label !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        <!-- <v-col cols="6" class="py-0">
                          <ValidationProvider 
                            name="Status Administrasi" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              <span class="red--text">*</span>
        
                              Status Administrasi
                            </div>
        
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Status Administrasi"
        
                              hide-details
                              :items="[
                                {
                                  label: 'Dapat Ubah Negosiasi & Penawaran saat Status Pelaksanaan',
                                  value: true
                                },
                                {
                                  label: 'Tidak Dapat Ubah Negosiasi & Penawaran saat Status Pelaksanaan',
                                  value: false
                                }
                              ]"
                              item-text="label"
                              item-value="value"
        
                              v-model="form.administrasi_bool"
                              :success="form.administrasi_bool !== '' && valid"
                              :error-messages="errors"
                              required
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
        
                                <div v-if="form.administrasi_bool !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col> -->
                        <v-col cols="12" class="pt-0">
                          <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                            Dokumen Surat Permohonan
                          </div> 
                          <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                            <div class="mr-3">
                              <uploadimage
                                v-model="upload.image" >
                                <div 
                                  slot="activator"
                                  class="cursor-pointer">
                                  <v-btn
                                    color="#4B4B4B"
                                    elevation="0"
                                    small
                                    :disabled="process.image"
                                    :loading="process.image"
                                    min-height="30"
                                    class="fs-12 white--text text-capitalize d-flex align-center"
                                    style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                    <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                    
                                    <span
                                      class="ml-2 ">
                                      Tambah Gambar
                                    </span>
                                  </v-btn>
                                </div>
                              </uploadimage>
                            </div>
                            <div class="mr-3">
                              <uploadfile
                                v-model="upload.document" >
                                <div 
                                  slot="activator"
                                  class="cursor-pointer">
                                  <v-btn
                                    color="primary"
                                    elevation="0"
                                    small
                                    :disabled="process.document"
                                    :loading="process.document"
                                    min-height="30"
                                    class="fs-12 white--text text-capitalize d-flex align-center"
                                    style="border-radius: 6px; font-weight: 600;">
                                    <v-icon size="15">mdi-file-document</v-icon>
                                    
                                    <span
                                      class="ml-2 ">
                                      Tambah File
                                    </span>
                                  </v-btn>
                                </div>
                              </uploadfile>
                            </div>
                          </div>

                          <div class="">
                            <table style="border: 1px solid #ededed; width: 100%;">
                              <tr>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  Aksi
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  Link
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  Dokumen Surat Permohonan
                                </th>
                              </tr>
                              <!-- <tr v-for="(item, index) in form.request_image" :key="index">
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="form.request_image.splice(index, 1)"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :href="item.url"
                                        target="_blank"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="indigo"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-image-area</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Lihat</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nama Dokumen ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors, valid }">
                                    <div class="mb-2 font_weight_600 fs-13 black_one">
                                      <span class="red--text">*</span>
                
                                      Nama Dokumen
                                    </div>
                
                                    <v-text-field
                                      v-on:keydown.enter.prevent="save()"
                                      
                                      filled
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Nama Dokumen"
                
                                      hide-details
                
                                      v-model="item.title"
                                      :success="item.title !== '' && valid"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                
                                        <div v-if="item.title !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div>
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                              </tr>
                              <tr v-for="(item, index) in form.request_file" :key="index">
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="form.request_file.splice(index, 1)"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :href="item.url"
                                        target="_blank"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        :color="item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">{{ item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Lihat</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nama Dokumen ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors, valid }">
                                    <div class="mb-2 font_weight_600 fs-13 black_one">
                                      <span class="red--text">*</span>
                
                                      Nama Dokumen
                                    </div>
                
                                    <v-text-field
                                      v-on:keydown.enter.prevent="save()"
                                      
                                      filled
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Nama Dokumen"
                
                                      hide-details
                
                                      v-model="item.title"
                                      :success="item.title !== '' && valid"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                
                                        <div v-if="item.title !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div>
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                              </tr> -->

                              <tr v-for="(item, index) in all_document" :key="index">
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="all_document.splice(index, 1)"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :href="item.url"
                                        target="_blank"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Lihat</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nama Dokumen Surat Permohonan ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors, valid }">
                                    <div class="mb-2 font_weight_600 fs-13 black_one">
                                      <span class="red--text">*</span>
                
                                      Nama Dokumen Surat Permohonan
                                    </div>
                
                                    <v-text-field
                                      v-on:keydown.enter.prevent="save()"
                                      
                                      filled
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Nama Dokumen Surat Permohonan"
                
                                      hide-details
                
                                      v-model="item.title"
                                      :success="item.title !== '' && valid"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                
                                        <div v-if="item.title !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div>
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                              </tr>
                            </table>
                          </div>


                          <v-card-text
                            v-if="all_document.length === 0"
                            class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                            <div class="text-center">
                              <div class="mt-3 fs-16">
                                Belum ada data Data Dokumen Surat Permohonan
                              </div>
                            </div>
                          </v-card-text>

                        </v-col> 
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4">
            <v-col 
              cols="12"
              md="8">
              <div v-if="message.error.length > 0"
                class="text-left d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-col>
            <v-col 
              cols="12"
              md="4"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                rounded
                color="success"
                class="fs-16 white--text text-capitalize">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/project"
                :disabled="process.form"
                color="red"
                elevation="0"
                rounded
                class="fs-16 white--text text-capitalize d-flex align-center ml-4"
                style="font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        unit: [],

        form: {
          id: '',
          name: '',
          code: '',
          client_id: '',
          location: '',
          request_number: '',
          request_date: '',
          request_file_object: [],
          request_file: [],
          request_image: [],
          type_file: 'image',
          duration_label: '',
          administrasi_bool: true
        },
        filename: [],
        upload: {
          image: null,
          document: null
        },
        all_document: [],
        client: [],
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false,
          document: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.request_image.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })
              this.all_document.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })

              this.upload.image = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.filename.push(this.upload.document.filename)
              this.form.request_file.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })
              this.all_document.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchClient()
    },
    methods: {

      async fetchClient () {
        let params = {
          pagination_bool: false,
        }

        await get(`client/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.client = res.results.data
          }
        })
      },

      async save () {
        this.message.error = ''
        this.form.request_file = this.all_document.filter(item => item.type !== 'image')
        this.form.request_image = this.all_document.filter(item => item.type === 'image')

        const isValid = await this.$refs.form.validate(),
              isDocument = this.form.request_file.length > 0 || this.form.request_image.length > 0
        this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Dokumen surat permohonan harus diisi' : ''
        if (isValid && isDocument) {
          this.process.form = true

          // SAVE TO REST API
          await post(`project/add`, {
            data: {
              name: this.form.name,
              code: this.form.code,
              client_id: this.form.client_id,
              location: this.form.location,
              request_number: this.form.request_number,
              request_date: this.form.request_date,
              duration_label: this.form.duration_label,
              // administrasi_bool: this.form.administrasi_bool,
              request_file_object: {
                "doc": this.form.request_file,
                "image": this.form.request_image
              }
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/project' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>